/* Cradles to Crayons page, generated by next-charities/build-next.py from the Hope's Door script. Page UI; the hero script follows. */
(function(){
  // FAQ accordion (PDP markup)
  document.querySelectorAll('#pdp-hopes-door .faq-q').forEach(function (h) {
    h.addEventListener('click', function () { h.parentElement.classList.toggle('open'); });
  });
  // closing band and mobile sticky bar scroll to the buy box
  var buy = document.querySelector('.pdphd-hero .col-buy');
  ['closing-cta', 'sticky-cta'].forEach(function (id) {
    var el = document.getElementById(id);
    if (el && buy) el.addEventListener('click', function () { buy.scrollIntoView({behavior: 'smooth', block: 'center'}); });
  });
  var bar = document.getElementById('sticky-bar'), cta = document.querySelector('#planSub .cta'), closing = document.getElementById('closing-cta');
  var buyVis = true, closeVis = false;
  function refresh(){ if (bar) bar.classList.toggle('visible', !buyVis && !closeVis); }
  if ('IntersectionObserver' in window && cta && closing) {
    new IntersectionObserver(function (e) { buyVis = e[0].isIntersecting; refresh(); }).observe(cta);
    new IntersectionObserver(function (e) { closeVis = e[0].isIntersecting; refresh(); }).observe(closing);
  }
})();
/* Hope's Door page hero: the live PDP's hero (sections/pdpx-laundry-sheets-main,
   pulled 16 Sep 2026) with the Hope's Door offer. Gallery, accordions, coupon,
   add-on rows and plan cards behave as on the PDP. Differences, all deliberate:
   - one-time is the 1-pack only at the list price (no pack tiles, no code),
     with its own quantity stepper;
   - the donation is pack for pack: one donated Fragrance Free pack per paid
     1-pack (the shared donation product's Hope's Door variant, $15-off-each
     shelter code), topped up, max 10;
     the site-wide pdphd-donation-cap.js trims it if the cart is edited;
   - codes go on through /cart/update.js {discount} and the UpCart drawer is
     refreshed afterwards, so it shows the discounted prices.
   Source: ~/jackwork Claude/charity-pdp-mockups/hero.js */
(function(){
var root = document.getElementById('pdp-hopes-door');
if (!root) return;
var $ = function(s){ return root.querySelector(s); };
var $$ = function(s){ return [].slice.call(root.querySelectorAll(s)); };

/* ---------- gallery (PDP) ---------- */
var stage = document.getElementById('stage');
var VID = 'https://cdn.shopify.com/videos/c/o/v/625f253e82dc4653ab43df9eed39aaab.mp4';
var POSTER = 'https://www.heysunday.com/cdn/shop/t/68/assets/pdp-hero-poster.jpg?v=41661069138871426181788467336';
document.getElementById('track').addEventListener('click', function(e){
  var t = e.target.closest('.thumb'); if (!t) return;
  $$('.thumb').forEach(function(x){ x.classList.remove('active'); });
  t.classList.add('active');
  if (t.dataset.type === 'video') stage.innerHTML = '<video src="' + VID + '" poster="' + POSTER + '" autoplay muted loop playsinline controls></video>';
  else stage.innerHTML = '<img class="' + (t.dataset.fit === 'contain' ? 'fit-contain' : '') + '" src="' + t.dataset.src + '" alt="' + (t.dataset.alt || '') + '">';
});
function gstep(d){
  var ths = $$('.thumb'), i = -1;
  ths.forEach(function(t, k){ if (t.classList.contains('active')) i = k; });
  if (i < 0) i = 0;
  i = (i + d + ths.length) % ths.length;
  ths[i].click(); ths[i].scrollIntoView({inline: 'center', block: 'nearest'});
}
var tnavs = $$('.tnav');
if (tnavs[0]) tnavs[0].addEventListener('click', function(){ gstep(-1); });
if (tnavs[1]) tnavs[1].addEventListener('click', function(){ gstep(1); });
(function(){
  var x0 = null;
  stage.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, {passive: true});
  stage.addEventListener('touchend', function(e){
    if (x0 == null) return;
    var dx = e.changedTouches[0].clientX - x0; x0 = null;
    if (Math.abs(dx) > 40) gstep(dx < 0 ? 1 : -1);
  }, {passive: true});
})();
$$('.acc-h').forEach(function(h){ h.addEventListener('click', function(){ h.parentElement.classList.toggle('open'); }); });

/* ---------- state ---------- */
var VARIANTS = {'Ocean Breeze': 44406385246495, 'Fragrance Free': 44406385279263};   // 1-pack, fallback 16 Sep
var PLANS = {'Every 30 Days': 8589246751, 'Every 60 Days': 8682897695};
var scent = 'Ocean Breeze', cadence = 'Every 30 Days', q = 1, qo = 1;
var ONCE = {p: 25, c: 0};                       // one-time is the list price (Jack, 17 Sep: no discount)
var SUBP = {'Every 30 Days': {n: 12.75, t: 15, c: 25}, 'Every 60 Days': {n: 14.45, t: 17, c: 25}};
var ADDONS = {
  dryer: {v: {'Ocean Breeze': 51356902162719, 'Fragrance Free': 51762343248159},
          plans: {'Every 30 Days': 8587116831, 'Every 60 Days': 8587149599, 'Every 90 Days': 12439814431},
          sub: 12, once: 20, handle: 'dryer-sheets'},
  dish:  {v: {'Ocean Breeze': 49226390765855, 'Fragrance Free': 49226390765855},
          plans: {'Every 30 Days': 8588689695, 'Every 60 Days': 8588722463, 'Every 90 Days': 12439847199},
          sub: 15, once: 25, handle: 'dishwasher-sheets'}
};
var COUPON_CODE = 'Extra Discount', COUPON_RATE = 0.85, COUPON_STORE_KEY = 'checkbox-coupon';
/* one donation product for every shelter, a variant per shelter (17 Sep), and
   one code scoped to the product, so a new shelter is a new variant only */
var DONATION_HANDLE = 'donate-a-pack-of-laundry-sheets';
var DONATION_SHELTER = "Cradles to Crayons (Philadelphia, PA)";
var DONATION_FALLBACK = 52943322218783;
var DONATION_CODE = "Donated packs on us";
var DONATION_MAX = 10;
var donationVariant = null;

function money(n){ return '$' + (Math.round(n * 100) % 100 ? n.toFixed(2) : n.toFixed(0)); }

function setScent(s){
  scent = s;
  $$('.var').forEach(function(x){
    var ff = x.textContent.indexOf('Fragrance') > -1;
    x.classList.toggle('on', ff === (s === 'Fragrance Free'));
  });
}
$$('.var').forEach(function(v){
  v.addEventListener('click', function(){ setScent(v.textContent.indexOf('Fragrance') > -1 ? 'Fragrance Free' : 'Ocean Breeze'); });
});
$$('#planSub .qty button').forEach(function(b){
  b.addEventListener('click', function(e){
    e.stopPropagation();
    q = Math.min(10, Math.max(1, q + parseInt(b.dataset.q, 10)));
    document.getElementById('qv').textContent = q;
    try { updSub(); } catch (err) {}
  });
});
$$('#planOnce .qty button').forEach(function(b){
  b.addEventListener('click', function(e){
    e.stopPropagation();
    qo = Math.min(10, Math.max(1, qo + parseInt(b.dataset.q, 10)));
    document.getElementById('qvOnce').textContent = qo;
  });
});
function renderOnce(){
  var oc = document.getElementById('planOnce');
  var n = oc.querySelector('.now'); if (n) n.textContent = money(ONCE.p);
}

/* ---------- ids and prices re-read at runtime; the maps above are the fallback ---------- */
function grab(handle, onOk, onFail){
  return fetch('/products/' + handle + '.js', {headers: {'Accept': 'application/json'}})
    .then(function(r){ if (!r.ok) throw new Error(handle + ' ' + r.status); return r.json(); })
    .then(onOk)
    .catch(function(e){ if (onFail) onFail(e); else console.warn('[cradles-to-crayons] id refresh failed, using fallback', e); });
}
function planMap(p){
  var out = {};
  (p.selling_plan_groups || []).forEach(function(g){ (g.selling_plans || []).forEach(function(sp){ out[sp.name] = sp.id; }); });
  return out;
}
var ready = Promise.all([
  grab('laundry-sheets', function(p){
    var v = {};
    p.variants.forEach(function(x){
      var m = String(x.title).split(' / ');
      if (m.length === 2 && m[1] === '1 Pack') {
        v[m[0]] = x.id;
        if (m[0] === 'Ocean Breeze' && x.price) ONCE.p = x.price / 100;
        (x.selling_plan_allocations || []).forEach(function(a){
          (p.selling_plan_groups || []).forEach(function(g){ (g.selling_plans || []).forEach(function(sp){
            if (sp.id === a.selling_plan_id && SUBP[sp.name] && m[0] === 'Ocean Breeze') {
              SUBP[sp.name].t = a.price / 100; SUBP[sp.name].c = x.price / 100;
              SUBP[sp.name].n = Math.round(a.price * COUPON_RATE) / 100;
            }
          }); });
        });
      }
    });
    if (v['Ocean Breeze'] && v['Fragrance Free']) VARIANTS = v;
    var pm = planMap(p);
    if (pm['Every 30 Days'] && pm['Every 60 Days']) { PLANS['Every 30 Days'] = pm['Every 30 Days']; PLANS['Every 60 Days'] = pm['Every 60 Days']; }
    try { renderOnce(); updSub(); } catch (e) {}
  }),
  grab('dryer-sheets', function(p){
    var pm = planMap(p), got = {};
    p.variants.forEach(function(x){
      var t = String(x.title);
      if (t.indexOf('1 Pack') < 0) return;
      var sc = t.indexOf('Fragrance Free') > -1 ? 'Fragrance Free' : (t.indexOf('Ocean Breeze') > -1 ? 'Ocean Breeze' : null);
      if (!sc) return;
      got[sc] = x.id;
      var a = (x.selling_plan_allocations || [])[0];
      if (a && a.price) ADDONS.dryer.sub = a.price / 100;
      if (x.price) ADDONS.dryer.once = x.price / 100;
    });
    if (got['Ocean Breeze'] && got['Fragrance Free']) ADDONS.dryer.v = got;
    Object.keys(ADDONS.dryer.plans).forEach(function(k){ if (pm[k]) ADDONS.dryer.plans[k] = pm[k]; });
    try { updSub(); } catch (e) {}
  }),
  grab('dishwasher-sheets', function(p){
    var pm = planMap(p), id = null;
    p.variants.forEach(function(x){
      if (String(x.title).indexOf('1 Pack') < 0) return;
      id = x.id;
      var a = (x.selling_plan_allocations || [])[0];
      if (a && a.price) ADDONS.dish.sub = a.price / 100;
      if (x.price) ADDONS.dish.once = x.price / 100;
    });
    if (id) ADDONS.dish.v = {'Ocean Breeze': id, 'Fragrance Free': id};
    Object.keys(ADDONS.dish.plans).forEach(function(k){ if (pm[k]) ADDONS.dish.plans[k] = pm[k]; });
    try { updSub(); } catch (e) {}
  }),
  grab(DONATION_HANDLE, function(p){
    var v = (p.variants || []).filter(function(x){ return x.title === DONATION_SHELTER && x.available !== false; })[0]
         || (p.variants || []).filter(function(x){ return x.id === DONATION_FALLBACK; })[0];
    donationVariant = v ? v.id : null;
    if (!donationVariant) console.warn('[cradles-to-crayons] no donation variant for', DONATION_SHELTER);
  }, function(e){ console.warn('[cradles-to-crayons] donation product missing, no donated pack will be added', e); })
]);

/* ---------- subscription card (PDP) ---------- */
function addonOn(k){ var c = $('.pdpad-cb[data-addon="' + k + '"]'); return !!(c && c.checked); }
function addonAny(){ return addonOn('dryer') || addonOn('dish'); }
function addonTotals(){
  var sp = SUBP[cadence] || SUBP['Every 30 Days'];
  var t = {first: sp.n * q, then: sp.t * q, cmp: sp.c * q};
  ['dryer', 'dish'].forEach(function(k){
    if (!addonOn(k)) return;
    t.then += ADDONS[k].sub; t.cmp += ADDONS[k].once; t.first += ADDONS[k].sub * COUPON_RATE;
  });
  return t;
}
function couponOn(){ return !!$('.coupon.checked'); }
function updSub(){
  var sp = SUBP[cadence] || SUBP['Every 30 Days'];
  var ps = document.getElementById('planSub');
  var on = couponOn(), t = addonTotals(), any = addonAny();
  var n = ps.querySelector('.now'); if (n) n.textContent = money(on ? t.first : t.then);
  var w = ps.querySelector('.was'); if (w) w.textContent = money(t.cmp);
  var pct = Math.round((1 - sp.t / sp.c) * 100);
  var b40 = ps.querySelector('.bold40'); if (b40) b40.textContent = b40.textContent.replace(/\d+% off/, pct + '% off');
  var f = ps.querySelector('.firstcycle');
  if (f) {
    if (on) {
      f.style.display = '';
      f.textContent = any ? 'for the first cycle, then ' + money(t.then) + ' on every order.'
                          : 'for the first cycle, then ' + money(sp.t) + '/pack on every order.';
    } else f.style.display = 'none';
  }
  ['dryer', 'dish'].forEach(function(k){
    var el = $('[data-addon-price="' + k + '"]');
    if (el) el.textContent = '+' + money(on ? ADDONS[k].sub * COUPON_RATE : ADDONS[k].sub);
    var wl = $('[data-addon-was="' + k + '"]'); if (wl) wl.textContent = money(ADDONS[k].once);
    var c = $('.pdpad-cb[data-addon="' + k + '"]');
    if (c && c.closest('.pdpad-row')) c.closest('.pdpad-row').classList.toggle('on', c.checked);
  });
}
$$('.pdpad-cb').forEach(function(c){ c.addEventListener('change', updSub); });
$$('.pdpad-row').forEach(function(r){ r.addEventListener('click', function(e){ e.stopPropagation(); }); });

/* coupon (PDP): one-way, on for ?coupon= arrivals or a stored tick */
function couponStored(){
  try { if (localStorage.getItem(COUPON_STORE_KEY)) return true; } catch (e) {}
  return ('; ' + document.cookie).indexOf('; ' + COUPON_STORE_KEY + '=') > -1;
}
function clearCoupon(){
  try { localStorage.removeItem(COUPON_STORE_KEY); } catch (e) {}
  document.cookie = COUPON_STORE_KEY + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
}
function storeCoupon(){
  try { localStorage.setItem(COUPON_STORE_KEY, COUPON_CODE); } catch (e) {}
  var d = new Date(); d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000);
  document.cookie = COUPON_STORE_KEY + '=' + COUPON_CODE + '; expires=' + d.toUTCString() + '; path=/';
}
(function couponInit(){
  var row = $('.coupon'); if (!row) return;
  var box = row.querySelector('.cbx');
  function setOn(on, applyNow){
    row.classList.toggle('checked', on);
    if (on) { storeCoupon(); if (applyNow) applyCodes([COUPON_CODE]); }
    else { clearCoupon(); if (applyNow) setCodes([], [COUPON_CODE]); }
    if (box) box.setAttribute('aria-checked', on ? 'true' : 'false');
    updSub();
  }
  setOn(/[?&]coupon=/.test(location.search) || couponStored(), true);
  function toggle(){ setOn(!row.classList.contains('checked'), true); }
  if (box) {
    box.addEventListener('click', function(e){ e.stopPropagation(); toggle(); });
    box.addEventListener('keydown', function(e){
      if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); toggle(); }
    });
  }
})();
var cad = $('#planSub select');
if (cad) cad.addEventListener('change', function(){ cadence = cad.value; updSub(); });
var sub = document.getElementById('planSub'), once = document.getElementById('planOnce');
function sel(w){
  var s = w === 'sub';
  sub.classList.toggle('sel', s); sub.classList.toggle('collapsed', !s);
  once.classList.toggle('sel', !s); once.classList.toggle('collapsed', s);
}
sub.addEventListener('click', function(){ sel('sub'); });
once.addEventListener('click', function(){ sel('once'); });

/* ---------- cart ---------- */
function j(url){
  return fetch(url, {headers: {'Accept': 'application/json'}, credentials: 'same-origin'})
    .then(function(r){ if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
}
function donationNeed(adding){
  if (!donationVariant) return Promise.resolve(0);
  var paidIds = [VARIANTS['Ocean Breeze'], VARIANTS['Fragrance Free']];
  return j('/cart.js').then(function(c){
    var sum = function(test){ return c.items.filter(test).reduce(function(n, i){ return n + i.quantity; }, 0); };
    var have = sum(function(i){ return i.variant_id === donationVariant; });
    var paid = sum(function(i){ return paidIds.indexOf(i.variant_id) >= 0; }) + adding;
    return Math.max(0, Math.min(DONATION_MAX, paid) - have);
  }).catch(function(){ return 0; });   // unknown cart: add nothing rather than guess
}
/* POST /cart/update.js {discount} REPLACES the cart's code set, so codes are
   added (or one removed) by sending the full set. window.__pdpxCouponApplying
   tells the site-wide cart guard (snippets/pdpx-cart-guard) not to read the
   cart as settled while this is in flight. */
function setCodes(add, remove){
  window.__pdpxCouponApplying = true;
  return j('/cart.js').then(function(c){
    var have = (c.discount_codes || []).map(function(d){ return d.code; })
      .filter(function(k){ return (remove || []).indexOf(k) < 0; });
    (add || []).forEach(function(k){ if (have.indexOf(k) < 0) have.push(k); });
    return fetch('/cart/update.js', {method: 'POST', credentials: 'same-origin',
      headers: {'Content-Type': 'application/json'}, body: JSON.stringify({discount: have.join(',')})});
  }).catch(function(e){ console.warn('[cradles-to-crayons] code update failed', e); })
    .then(function(){ window.__pdpxCouponApplying = false; });
}
function applyCodes(codes){ return codes.length ? setCodes(codes, []) : Promise.resolve(); }
/* after the add: re-read the cart and re-send once if an expected code is
   missing (the laundry PDP's verify-and-heal step, 17 Sep) */
function healCodes(codes){
  if (!codes.length) return Promise.resolve();
  return j('/cart.js').then(function(c){
    var have = (c.discount_codes || []).map(function(d){ return d.code; });
    var missing = codes.filter(function(k){ return have.indexOf(k) < 0; });
    if (missing.length) return setCodes(missing, []);
  }).catch(function(){});
}
function openDrawer(res){
  try {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !res || !res.sections) { location.href = '/cart'; return; }
    drawer.classList.remove('is-empty');
    var dh = res.sections['cart-drawer'];
    if (dh) {
      var t = document.createElement('div'); t.innerHTML = dh;
      var ni = t.querySelector('.drawer__inner'), ci = drawer.querySelector('.drawer__inner');
      if (ni && ci) ci.innerHTML = ni.innerHTML;
    }
    if (typeof drawer.open === 'function') drawer.open(); else location.href = '/cart';
  } catch (e) { location.href = '/cart'; }
}
function openCart(){
  if (typeof window.upcartRefreshCart === 'function' && typeof window.upcartOpenCart === 'function') {
    return Promise.resolve(window.upcartRefreshCart()).catch(function(){}).then(function(){ window.upcartOpenCart(); });
  }
  return fetch('/cart/update.js', {method: 'POST', credentials: 'same-origin',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({updates: {}, sections: ['cart-drawer', 'cart-icon-bubble']})
  }).then(function(r){ return r.json(); }).then(openDrawer);
}
function addToCart(mode, btn){
  if (btn) btn.classList.add('loading');
  var items = [], adding = 0, wantCoupon = mode === 'sub' && couponOn(), codes = [];
  window.__pdpxAdding = true;
  ready.then(function(){
    if (mode === 'sub') {
      items.push({id: VARIANTS[scent], quantity: q, selling_plan: PLANS[cadence]});
      adding = q;
      ['dryer', 'dish'].forEach(function(k){
        if (!addonOn(k)) return;
        var vid = ADDONS[k].v[scent], pid = ADDONS[k].plans[cadence];
        if (vid && pid) items.push({id: vid, quantity: 1, selling_plan: pid});
      });
    } else {
      items.push({id: VARIANTS[scent], quantity: qo});
      adding = qo;
    }
    return donationNeed(adding);
  }).then(function(need){
    if (need > 0) items.push({id: donationVariant, quantity: need});
    return fetch('/cart/add.js', {method: 'POST', credentials: 'same-origin',
      headers: {'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
      body: JSON.stringify({items: items, attributes: {_offer: 'cradles-to-crayons'}})});
  }).then(function(r){ if (!r.ok) throw new Error('cart/add ' + r.status); })
  .then(function(){
    if (donationVariant) codes.push(DONATION_CODE);
    if (wantCoupon) codes.push(COUPON_CODE);
    return applyCodes(codes);
  })
  .then(function(){ return healCodes(codes); })
  .then(function(){ window.__pdpxAdding = false; if (btn) btn.classList.remove('loading'); return openCart(); })
  .catch(function(err){
    window.__pdpxAdding = false;
    console.error('[cradles-to-crayons] add to cart failed', err, items);
    if (btn) btn.classList.remove('loading');
    location.href = '/cart';
  });
}
sub.querySelector('.cta').addEventListener('click', function(e){ e.stopPropagation(); sel('sub'); addToCart('sub', e.currentTarget); });
once.querySelector('.cta').addEventListener('click', function(e){ e.stopPropagation(); sel('once'); addToCart('once', e.currentTarget); });
try { renderOnce(); updSub(); } catch (e) { console.error('[cradles-to-crayons] initial render', e); }
window.updSub = updSub;

window.PDPHD_debug = function(){
  return ready.then(function(){ return {variants: VARIANTS, plans: PLANS, subp: SUBP, once: ONCE, addons: ADDONS, donationVariant: donationVariant, scent: scent, cadence: cadence, q: q, qo: qo, coupon: couponOn()}; });
};
})();
